import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../../Utils/ReactSelectComponents';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import InputLabel from '@material-ui/core/InputLabel';
import DeleteIcon from '@material-ui/icons/Delete';
import OrderIcon from '@material-ui/icons/AssignmentTurnedIn';
import NoDealIcon from '@material-ui/icons/RemoveShoppingCart';
import SaveIcon from '@material-ui/icons/Save';
import SGEIcon from '@material-ui/icons/CompareArrows';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import RUCarOptionals from './RUCarOptionals';
import RUCarsListAPI from '../../../../API/UsedRentalsCarsListAPI';
import DropdownListAPI from '../../../../API/DropdownListAPI';
import OptionalsAPI from '../../../../API/OptionalsAPI';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import RUCarOrderAssociation from './UsedRentalsCarOrdering/RUCarOrderAssociation';
import RUSubLotExpansionPanel from '../../UsedRentalsCreation/UsedRentalsEditLots/RUSubLotExpansionPanel';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { UR_GROUP, UR_PHASE } from '../../../../Utils/Constants';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedInput from 'react-text-mask';
import { FormatDate, FormatDateTime, ConvertToBool, ConvertFromBool } from '../../../Utils/GenericFunctions';
import NOLSSyncAPI from '../../../../API/NOLSSyncAPI';


const headerData = [
  { id: 'brand', label: 'MARCA' },
  { id: 'carModel', label: 'MODELO' },
  { id: 'color', label: 'COR' },
  { id: 'saleschannels', label: 'CANAIS VENDA' },
  { id: 'licensePlate', label: 'MATRÍCULA' },
  { id: 'licensePlateDate', label: 'DATA MATRÍCULA' },
  { id: 'stockentrydate', label: 'DATA STOCK' },
  { id: 'ageing', label: 'AGEING' }
];

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  textWhite: {
    color: '#ffffff'
  },
  divSpacing: {
    padding: '0px 32px',
    marginTop: '152px'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    padding: 0
  },
  tblRow: {
    height: '30px',
    backgroundColor: '#F2F2F2',
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1'
    }
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  headColor: {
    backgroundColor: '#A5A5A5',
    margin: 0,
    width: '100%',
    padding: '12px 24px'
  },
  gridRoot: {
    flexGrow: 1,
    marginTop: '8px'
  },
  gridRootTransport: {
    marginBottom: '24px'
  },
  group: {
    display: 'inline-block'
  },
  dividerHead: {
    borderBottom: '2px solid #007b7a'
  },
  marginHead: {
    marginTop: '12px'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  flex: {
    flex: 1
  },
  width100: {
    width: '100%'
  },
  paddingAlign: {
    paddingTop: '6px'
  },
  toolbarHeight: {
    minHeight: '52px'
  },
  sgeText: {
    fontSize: '10px',
    height: '32px',
    lineHeight: '52px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={10}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

function InputCurrency(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        if (values.value.length <= 8) {
          onChange({ target: { value: values.value } });
        }
      }}
      decimalScale={2}
      thousandSeparator={'.'}
      decimalSeparator={','}
      allowNegative={true}
      suffix={'€'}
      isNumericString={true}
      allowEmptyFormatting={false}
      maxLength={12}
    />
  );
}
InputCurrency.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy', { maxYear: new Date().getFullYear() });

const DateMask = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={' '}
    />
  );
}
DateMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


class CarDetailInfo extends React.Component {
  l4ListAPI;

  constructor(props) {
    super(props);
    this.state = {
      colorData: [],
      color: { value: this.props.carDetail.ColourID, label: this.props.carDetail.ColourDescription },
      Chassis: '',
      LicensePlate: '',
      LicensePlateDate: '',
      SupplierName: '',
      SupplierNumber: '',
      SubSupplierNumber: '',
      DeliverySupplierName: '',
      DeliverySupplierNumber: '',
      DeliverySubSupplierNumber: '',
      InitialKM: '',
      Observations: '',
      ReferenceRentalPrice: '',
      NumClientReferenceProposal: '',
      TransportObservations: '',
      VehicleLocation: '',
      StockAvailable: 'no',
      A1Created: 'no',
      TransportManagement: 'no',
      Reservation: 'no',
      StockEntryDate: '',
      DeliveryDeadline: '',
      EffectiveDeliveryDate: '',
      OriginLocal: '',
      DestinationLocal: '',
      RequestDate: '',
      DestinationExpectedDate: '',
      DestinationArrivalDate: '',
      ExpectedDeliveryDate: '',
      SgeLastUpdate: '',
      SgeUpdateResult: '',
      AnnouncedOptionals: [],
      loading: false,
      success: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      changedValueDetected: false,
      openError: false,
      alertMessage: '',
      openDialogForced: false,
      ruL4Data: {},
      openOrderDialog: false,
      optionalsData: [],
      lotPhase: 'RU_Car',
      saleChannel: [],
      saleChannelData: [],
      SalesChannelString: '',
      NumA1Proposal: ''
    };
    this.l4ListAPI = new RUCarsListAPI();
  }

  componentDidMount() {
    const dropdownListDataAPI = new DropdownListAPI();
    const optionalsDataAPI = new OptionalsAPI();
    Promise.all([optionalsDataAPI.getAllOptionals(), dropdownListDataAPI.getAllColors(), dropdownListDataAPI.getAllSalesChannels(), this.getCarInfo()]).then((response) => {
      this.setState({
        optionalsData: response[0].data,
        colorData: response[1].data,
        saleChannelData: response[2].data
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  getCarInfo() {
    const salesChannelsLabels = [];
    this.l4ListAPI.getRUCarByL4Id(this.props.carDetail.L4ID).then((response) => {
      response.data.ListSalesChannel.forEach((item) => {
        salesChannelsLabels.push(item.label);
      });
      this.setState({
        ruL4Data: response.data,
        saleChannel: response.data.ListSalesChannel,
        SalesChannelString: salesChannelsLabels.join(' || '),
        Chassis: response.data.Chassis,
        LicensePlate: response.data.LicensePlate,
        LicensePlateDate: FormatDate(response.data.LicensePlateDate),
        SupplierName: response.data.ProviderName,
        SupplierNumber: response.data.ProviderNumber,
        SubSupplierNumber: response.data.SubProviderNumber,
        DeliverySupplierName: response.data.DeliverySupplierName,
        DeliverySupplierNumber: response.data.DeliverySupplier,
        DeliverySubSupplierNumber: response.data.DeliverySupplierSeq,
        InitialKM: response.data.InitialKm,
        Observations: response.data.Observations,
        ReferenceRentalPrice: response.data.ReferenceRentalPrice,
        NumClientReferenceProposal: response.data.NumClientReferenceProposal,
        TransportObservations: response.data.TransportObservations,
        VehicleLocation: response.data.VehicleLocation,
        StockAvailable: ConvertFromBool(response.data.Stock),
        A1Created: ConvertFromBool(response.data.A1Created),
        TransportManagement: ConvertFromBool(response.data.Transportation),
        Reservation: ConvertFromBool(response.data.Booking),
        StockEntryDate: FormatDate(response.data.StockEntryDate),
        DeliveryDeadline: response.data.DeliveryDeadline,
        EffectiveDeliveryDate: FormatDate(response.data.EffectiveDeliveryDate),
        OriginLocal: response.data.OriginalLocation,
        DestinationLocal: response.data.DestinationLocation,
        RequestDate: FormatDate(response.data.RequestDate),
        DestinationExpectedDate: FormatDate(response.data.DestinationExpectedDate),
        DestinationArrivalDate: FormatDate(response.data.DestinationArrivalDate),
        SgeLastUpdate: FormatDateTime(response.data.SgeLastUpdate),
        SgeUpdateResult: response.data.SgeUpdateResult,
        AnnouncedOptionals: response.data.ListAnnouncedOptionalsDescription,
        NumA1Proposal: response.data.NumA1Proposal,
        ExpectedDeliveryDate: FormatDate(response.data.ExpectedDeliveryDate)
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: error.response
      })
    });
  };

  reloadCarTable() {
    this.l4ListAPI.getRUCarByL4Id(this.props.carDetail.L4ID).then((response) => {
      this.setState({
        ruL4Data: response.data
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: error.response
      })
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleCloseOrderDialog = () => {
    this.setState({ openOrderDialog: false });
    this.getCarInfo();
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleCloseDialogForced = () => {
    this.setState({ openDialogForced: false });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
    this.detectChange();
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
    this.detectChange();
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  }

  handleGoBack = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
    this.props.reloadL4Table()
  };

  handleClickCarToSGE = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ATUALIZAR o SGE com as informação desta viatura?',
      confirmationMessage: 'A informação relativamente à viatura da marca ' + this.props.carModelData.Brand + ', modelo ' + this.props.carModelData.Model +
        ' e cor ' + this.state.color.label + ' será guardada.',
      confirmationFunction: this.handleSubmitSaveCarOnSGE,
      cancelFunction: this.handleCloseDialog
    });
  }

  handleClickSaveCarDetail = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR a informação da viatura?',
      confirmationMessage: 'A informação relativamente à viatura da marca ' + this.props.carModelData.Brand + ', modelo ' + this.props.carModelData.Model +
        ' e cor ' + this.state.color.label + ' será guardada.',
      confirmationFunction: () => this.handleSubmitSaveCarDetail(false),
      cancelFunction: this.handleCloseDialog
    });
  }

  parseStateForSubmit(state, carId, forceSave) {
    let SaleChannelIds = [];
    state.saleChannel.forEach((item) => {
      SaleChannelIds.push(item.value);
    });

    return {
      L4ID: carId,
      listSalesChannelIds: SaleChannelIds,
      ColourID: state.color.value,
      Chassis: state.Chassis,
      LicensePlate: state.LicensePlate,
      LicensePlateDate: state.LicensePlateDate,
      InitialKm: state.InitialKM,
      Stock: ConvertToBool(state.StockAvailable),
      A1Created: ConvertToBool(state.A1Created),
      Transportation: ConvertToBool(state.TransportManagement),
      Booking: ConvertToBool(state.Reservation),
      StockEntryDate: state.StockEntryDate,
      DeliveryDeadline: state.DeliveryDeadline,
      OriginalLocation: state.OriginLocal,
      DestinationLocation: state.DestinationLocal,
      RequestDate: state.RequestDate,
      DestinationExpectedDate: state.DestinationExpectedDate,
      DestinationArrivalDate: state.DestinationArrivalDate,
      Observations: state.Observations,
      TransportObservations: state.TransportObservations,
      ForceSave: forceSave,
      ExpectedDeliveryDate: state.ExpectedDeliveryDate,
      DeliverySupplier: state.DeliverySupplierNumber,
      DeliverySupplierSeq: state.DeliverySubSupplierNumber
    }
  };

  handleConfirmForceSave = (possibleToForce) => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationFunction: possibleToForce === true ? () => this.handleSubmitSaveCarDetail(true) : this.handleCloseDialogForced,
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleSubmitSaveCarDetail = (forceSave) => {
    if (!!this.state.LicensePlate && this.state.LicensePlate.length !== 6) {
      this.handleCloseDialog();
      return this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: 'Matrícula deve ter 6 caracteres'
      });
    }
    else if (!!this.state.Chassis && this.state.Chassis.length !== 17) {
      this.handleCloseDialog();
      return this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: 'Chassis deve ter 17 caracteres'
      });
    }
    else {
      this.setState({ loading: true })
      let ruL4DTO = this.parseStateForSubmit(this.state, this.props.carDetail.L4ID, forceSave);
      this.l4ListAPI.updateCarInformation(ruL4DTO).then(() => {
        this.setState({
          loading: false,
          success: true,
          changedValueDetected: false
        });
        setTimeout(() => {
          this.setState({
            success: false
          });
          this.handleCloseDialog();
          this.handleCloseDialogForced();
          this.reloadCarTable();
          this.props.reloadL4Table();
        }, 200)
      }).catch((error) => {
        let errorMessage = handleServerError(error);
        if (errorMessage.indexOf('sejam alertados') > -1) {
          this.setState({
            confirmationQuestion: 'Tem a certeza que pretende MODIFICAR FLAGS STOCK | RESERVA da viatura?',
            confirmationMessage: 'As viaturas da marca ' + this.props.carModelData.Brand + ' e modelo ' + this.props.carModelData.Model +
              ' possuem reservas associadas à totalidade de viaturas disponíveis, a mudança das flags de Stock e/ou Reserva terá impacto sobre as reservas. '
              + handleServerError(error)
          })
          this.handleConfirmForceSave(true);
        }
        else if (errorMessage.indexOf('viatura encomendada e entregue') > -1) {
          this.setState({
            confirmationQuestion: 'Tem a certeza que pretende MODIFICAR MATRÍCULA | CHASSIS da viatura?',
            confirmationMessage: handleServerError(error) + ' A alteração criará registos com matrícula e/ou chassis iguais.'
          })
          this.handleConfirmForceSave(true);
        }
        else {
          this.setState({
            loading: false,
            success: false,
            openError: true,
            alertMessage: errorMessage
          });
          if (errorMessage.indexOf('Não é possível alterar a cor') > -1 || errorMessage.indexOf('cancelem as mesmas') > -1) {
            this.setState({
              color: { value: this.props.carDetail.ColourID, label: this.props.carDetail.ColourDescription }
            });
          }
          this.handleCloseDialog();
          this.handleCloseDialogForced();
        }
      });
    }
  };

  handleClickOrder = () => {
    this.handleSubmitSaveCarDetail();
    this.setState({ openOrderDialog: true });
    this.handleCloseDialog();
  };

  handleOrderAssociate = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Existem alterações nos campos que não foram gravadas.',
        confirmationMessage: 'A informação relativamente às alterações executadas serão gravadas',
        confirmationFunction: this.handleClickOrder,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClickOrder();
    }
    this.props.reloadL4Table()
  };

  handleSubmitSaveCarOnSGE = () => {
    const nolsSyncAPI = new NOLSSyncAPI();
    nolsSyncAPI.sendUpdateOrderRuL4(this.props.carDetail.L4ID).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
        this.getCarInfo();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false
      })
      console.log(error);
      this.handleCloseDialog();
    });
  };

  handleClickQuitDeal = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende DESISTIR DO NEGÓCIO da viatura?',
      confirmationMessage: 'A informação relativamente a: Nº Encomenda, Cliente, Data Registo, Data Prevista Chegada Destino, Data Chegada Destino e Data Efetiva Entrega será limpa. ' +
        'As flags Stock, Reserva e Transporte colocadas a não e a viatura ficará disponível para um novo negócio.',
      confirmationFunction: this.handleSubmitQuitDeal,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitQuitDeal = () => {
    this.setState({ loading: true })
    this.l4ListAPI.quitDeal(this.state.ruL4Data.L4ID, false).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleCloseDialog();
        this.getCarInfo();
        this.reloadCarTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog();
    });
  };

  handleClickDelete = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR a viatura?',
      confirmationMessage: 'A informação relativamente à viatura será eliminada e esta apenas poderá ser visualizada na base de dados.',
      confirmationFunction: () => this.handleSubmitDelete(false),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleConfirmDeleteCar = () => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR a viatura?',
      confirmationFunction: () => this.handleSubmitDelete(true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleSubmitDelete = (forceSave) => {
    this.setState({ loading: true })
    this.l4ListAPI.deleteCar(this.state.ruL4Data.L4ID, forceSave).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
        this.handleClose();
        this.props.reloadL4Table();
      }, 500)
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('cancelem as mesmas') > -1) {
        this.setState({
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand + ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis, a eliminação da viatura terá impacto sobre as reservas. '
            + handleServerError(error)
        })
        this.handleConfirmDeleteCar();
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
  };

  renderTableHeader() {
    const { classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell key={column.id} padding='none' className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter)}>
              {column.label}
            </TableCell>
          );
        }, this)}
      </TableRow>
    );
  }

  renderTableRecords(carInfo, lotInfo) {
    const { classes } = this.props;

    return (
      <TableRow tabIndex={-1} key={carInfo.L4ID} className={classes.tblRow}>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.Brand}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.Model}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.ColourDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.SalesChannelsDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.LicensePlate}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {FormatDate(carInfo.LicensePlateDate)}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {FormatDate(carInfo.StockEntryDate)}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.Ageing}
        </TableCell>
      </TableRow>
    );
  }

  refreshOptionalsGrid(updatedAnnouncedOptionals) {
    this.setState({ AnnouncedOptionals: updatedAnnouncedOptionals });
  }

  renderOptionalsGrid() {
    const { classes } = this.props;

    const aOptionalsDescriptions = this.state.AnnouncedOptionals.map((oOptional) => {
      return (
        <Grid item xs={12} sm={2}>
          <Typography variant='body1' className={classes.textWhite}>
            {oOptional}
          </Typography>
        </Grid>
      );
    });

    return (
      <div>
        <Grid item xs={12} sm={12} className={classNames(classes.marginHead, classes.dividerHead)}>
          <Grid container alignItems='center'>
            <Grid item xs={12} sm={6}>
              <Typography variant='headline'>OPCIONAIS ANUNCIADOS L4</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-end' alignItems='center'>
                <RUCarOptionals estadoLotId={this.props.estadoLotId} carId={this.props.carDetail.L4ID} refreshOptionalsGrid={this.refreshOptionalsGrid.bind(this)} optionalsData={this.state.optionalsData} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={8} justify='flex-start' alignItems='center' className={classes.headColor}>
            {aOptionalsDescriptions}
          </Grid>
        </Grid>
      </div>
    );
  }

  renderCarDetail() {
    const { classes } = this.props;

    return (
      <form>
        <Grid container spacing={8} className={classes.gridRoot}>
          <Grid item xs={12} sm={12}>
            <TextField
              id='numA1Proposal'
              label='Nº PROPOSTA AQUISIÇÃO A1'
              fullWidth
              value={this.state.NumA1Proposal !== null && this.state.NumA1Proposal !== undefined ? this.state.NumA1Proposal.toString() : ''}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='numClientReferenceProposal'
              label='Nº PROPOSTA DE REF. CLIENTES'
              fullWidth
              value={this.state.NumClientReferenceProposal !== null && this.state.NumClientReferenceProposal !== undefined ? this.state.NumClientReferenceProposal.toString() : ''}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='referenceRentalPrice'
              label='RENDA REFERÊNCIA (€)'
              fullWidth
              value={this.state.ReferenceRentalPrice !== null && this.state.ReferenceRentalPrice !== undefined ? this.state.ReferenceRentalPrice.toString() : ''}
              InputProps={{ readOnly: true, inputComponent: InputCurrency }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='orderNumber'
              label='Nº ENCOMENDA'
              fullWidth
              InputProps={{ readOnly: true }}
              value={this.state.ruL4Data.OrderNumber ? this.state.ruL4Data.OrderNumber : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='orderStatus'
              label='ESTADO DA ENCOMENDA'
              fullWidth
              InputProps={{ readOnly: true }}
              value={this.state.ruL4Data.OrderStatus ? this.state.ruL4Data.OrderStatus : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='customer'
              label='CLIENTE'
              fullWidth
              InputProps={{ readOnly: true }}
              value={this.state.ruL4Data.ClientName ? this.state.ruL4Data.ClientName : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='customerExpectedDeliveryDate'
              label='DATA ENTREGA PRETENDIDA PELO CLIENTE'
              fullWidth
              InputProps={{ readOnly: true }}
              value={this.state.ruL4Data.CustomerExpectedDeliveryDate ? FormatDate(this.state.ruL4Data.CustomerExpectedDeliveryDate) : ''}
            />
          </Grid>

          {this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ?
            <Grid item xs={12} sm={6}>
              <TextField
                id='color'
                label='COR'
                fullWidth
                className={classes.paddingAlign}
                InputProps={{ readOnly: true }}
                value={this.state.color.label}
              />
            </Grid>
            :
            <Grid item xs={12} sm={6}>
              <Grid container justify='center'>
                <div className={classes.width100}>
                  <InputLabel htmlFor='color'>COR</InputLabel>
                  <ReactSelect
                    classes={classes}
                    options={this.state.colorData}
                    components={components}
                    value={this.state.color}
                    onChange={this.handleChangeSelect('color')}
                    placeholder=''
                  />
                </div>
              </Grid>
            </Grid>
          }

          <Grid item xs={12} sm={6}>
            <TextField
              id='chassis'
              label='CHASSIS'
              fullWidth
              className={classes.paddingAlign}
              inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 17 }}
              value={this.state.Chassis}
              onChange={this.handleChange('Chassis')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='licensePlate'
              label='MATRÍCULA'
              fullWidth
              inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 6 }}
              value={this.state.LicensePlate}
              onChange={this.handleChange('LicensePlate')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='licensePlateDate'
              label='DATA MATRÍCULA (dd/mm/aaaa)'
              fullWidth
              type='text'
              InputProps={{
                inputComponent: DateMask,
                value: this.state.LicensePlateDate,
                pipe: autoCorrectedDatePipe,
                placeholder: '',
                onChange: this.handleChange('LicensePlateDate'),
                guide: false,
                readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='supplierName'
              label='NOME FORNECEDOR'
              fullWidth
              inputProps={{ readOnly: true }}
              value={this.state.SupplierName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='supplierNumber'
              label='Nº FORNECEDOR'
              fullWidth
              value={this.state.SupplierNumber}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='subSupplierNumber'
              label='Nº SUB FORNECEDOR'
              fullWidth
              value={this.state.SubSupplierNumber}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='deliverySupplierName'
              label='NOME FORNECEDOR ENTREGA'
              fullWidth
              value={this.state.DeliverySupplierName}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='deliverySupplierNumber'
              label='Nº FORNECEDOR ENTREGA'
              fullWidth
              value={this.state.DeliverySupplierNumber}
              InputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, inputComponent: InputNumber }}
              onChange={this.handleChange('DeliverySupplierNumber')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='deliverySubDeliverySupplierNumber'
              label='Nº SUB FORNECEDOR ENTREGA'
              fullWidth
              value={this.state.DeliverySubSupplierNumber}
              InputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, inputComponent: InputNumber }}
              onChange={this.handleChange('DeliverySubSupplierNumber')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='initialKM'
              label='KM INICIAIS'
              fullWidth
              value={this.state.InitialKM}
              onChange={this.handleChange('InitialKM')}
              InputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, inputComponent: InputNumber }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='observations'
              label='OBSERVAÇÕES VIATURA'
              fullWidth
              multiline
              rows='1'
              rowsMax='3'
              inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 500 }}
              value={this.state.Observations}
              onChange={this.handleChange('Observations')}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id='vehicleLocation'
              label='LOCALIZAÇÃO VIATURA'
              fullWidth
              InputProps={{ readOnly: true }}
              value={this.state.ruL4Data.VehicleLocation ? this.state.ruL4Data.VehicleLocation : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={8} justify='flex-start' alignItems='center'>
              <Grid item>
                <FormLabel component='legend'>DISPONIBILIZAR PARA STOCK:</FormLabel>
              </Grid>
              <Grid item>
                <FormControl component='fieldset'>
                  <RadioGroup
                    name='stockAvailable'
                    className={classes.group}
                    inputprops={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 }}
                    value={this.state.StockAvailable}
                    onChange={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ? null : this.handleChange('StockAvailable')}
                  >
                    <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                    <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={8} justify='flex-start' alignItems='center'>
              <Grid item>
                <FormLabel component='legend'>A1 CRIADO:</FormLabel>
              </Grid>
              <Grid item>
                <FormControl component='fieldset'>
                  <RadioGroup
                    name='a1Created'
                    className={classes.group}
                    inputprops={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 }}
                    value={this.state.A1Created}
                    onChange={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ? null : this.handleChange('A1Created')}
                  >
                    <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                    <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={8} justify='flex-start' alignItems='center'>
              <Grid item>
                <FormLabel component='legend'>GESTÃO DE TRANSPORTE:</FormLabel>
              </Grid>
              <Grid item>
                <FormControl component='fieldset'>
                  <RadioGroup
                    name='transportManagement'
                    className={classes.group}
                    inputprops={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 }}
                    value={this.state.TransportManagement}
                    onChange={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ? null : this.handleChange('TransportManagement')}
                  >
                    <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                    <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={8} justify='flex-start' alignItems='center'>
              <Grid item>
                <FormLabel component='legend'>RESERVA:</FormLabel>
              </Grid>
              <Grid item>
                <FormControl component='fieldset'>
                  <RadioGroup
                    name='reservation'
                    className={classes.group}
                    inputprops={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 }}
                    value={this.state.Reservation}
                    onChange={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ? null : this.handleChange('Reservation')}
                  >
                    <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                    <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} color='primary' />} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='deliveryDeadline'
              label='PRAZO DE ENTREGA (dias úteis)'
              fullWidth
              InputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 }}
              value={this.state.DeliveryDeadline}
              onChange={this.handleChange('DeliveryDeadline')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='effectiveDeliveryDate'
              label='DATA EFETIVA ENTREGA (dd/mm/aaaa)'
              fullWidth
              type='text'
              InputProps={{
                inputComponent: DateMask,
                value: this.state.EffectiveDeliveryDate,
                pipe: autoCorrectedDatePipe,
                placeholder: '',
                guide: false,
                readOnly: true
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='stockEntryDate'
              label='DATA ENTRADA STOCK (dd/mm/aaaa)'
              fullWidth
              type='text'
              InputProps={{
                inputComponent: DateMask,
                value: this.state.StockEntryDate,
                pipe: autoCorrectedDatePipe,
                placeholder: '',
                onChange: this.handleChange('StockEntryDate'),
                guide: false,
                readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
              }}
            />
          </Grid>
        </Grid>


        {this.state.TransportManagement === 'yes' ?
          <Grid container spacing={8} className={classNames(classes.gridRoot, classes.gridRootTransport)}>
            <Grid item xs={12} sm={12}>
              <Typography className={classNames(classes.dividerHead, classes.marginHead)} variant='headline'>TRANSPORTE</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='transportObservations'
                label='OBSERVAÇÕES TRANSPORTE'
                fullWidth
                multiline
                rows='1'
                rowsMax='3'
                inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 500 }}
                value={this.state.TransportObservations}
                onChange={this.handleChange('TransportObservations')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='originLocal'
                label='LOCAL DE ORIGEM'
                fullWidth
                inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 200 }}
                value={this.state.OriginLocal}
                onChange={this.handleChange('OriginLocal')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='destinationLocal'
                label='LOCAL DE DESTINO'
                fullWidth
                inputProps={{ readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 200 }}
                value={this.state.DestinationLocal}
                onChange={this.handleChange('DestinationLocal')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='requestDate'
                label='DATA PEDIDO TRANSPORTE (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.RequestDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('RequestDate'),
                  guide: false,
                  readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='destinationExpectedDate'
                label='DATA PREVISTA CHEGADA DESTINO (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.DestinationExpectedDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('DestinationExpectedDate'),
                  guide: false,
                  readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='destinationArrivalDate'
                label='DATA CHEGADA DESTINO (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.DestinationArrivalDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('DestinationArrivalDate'),
                  guide: false,
                  readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='effectiveDeliveryDate'
                label='DATA EFETIVA ENTREGA (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.EffectiveDeliveryDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  guide: false,
                  readOnly: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='expectedDeliveryDate'
                label='DATA PREVISTA DE ENTREGA (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.ExpectedDeliveryDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('ExpectedDeliveryDate'),
                  guide: false,
                  readOnly: this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
          </Grid>
          : null
        }

      </form>
    );
  }


  render() {
    const { classes } = this.props;

    let subLots = null;
    if (this.state.ruL4Data.L2ID) {
      subLots = (
        <RUSubLotExpansionPanel
          key={this.state.ruL4Data.L2ID}
          subLotId={this.state.ruL4Data.L2ID}
          handleClose={this.handleClose.bind(this)}
          detectChange={this.detectChange.bind(this)}
          optionalsData={this.state.optionalsData}
          estadoId={this.props.estadoLotId}
          lotPhase={this.state.lotPhase}
        />
      );
    }

    return (
      <div>
        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight} >
            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack}>
                <ReturnIcon />
              </Button>
            </Tooltip>
            <Typography variant='title' className={classes.flex}>
              DETALHE VIATURA
            </Typography>
            <Typography variant='body1' className={classes.sgeText}>
              {this.state.SgeLastUpdate}
            </Typography>
            <Typography variant='body1' className={classNames(classes.sgeText, classes.cellPadding)}>
              {this.state.SgeUpdateResult}
            </Typography>
            <Tooltip title='Ligação ao NOLS' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickCarToSGE() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <SGEIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Guardar' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickSaveCarDetail() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <SaveIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Associar Encomenda' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleOrderAssociate() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <OrderIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Desistir do Negócio' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickQuitDeal() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <NoDealIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Eliminar Viatura' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickDelete() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <DeleteIcon />
              </Button>
            </Tooltip>
          </Toolbar>

          <Paper className={classes.tableWrapper}>
            <Table>
              <TableHead className={classes.tblHead}>
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableRecords(this.state.ruL4Data, this.props.carModelData)}
              </TableBody>
            </Table>
          </Paper>

        </AppBar>

        <div className={classes.divSpacing}>

          <Grid item xs={12} sm={12}>
            <Grid container justify='center'>
              <div className={classes.width100}>
                {this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ?
                  <TextField
                    id='saleChannels'
                    fullWidth
                    label='CANAL DE VENDA'
                    InputProps={{ readOnly: true }}
                    value={this.state.SalesChannelString}
                  />
                  :
                  <React.Fragment>
                    <InputLabel key={'0'} htmlFor='saleChannel'>CANAL DE VENDA</InputLabel>
                    <ReactSelect
                      key={'1'}
                      classes={classes}
                      options={this.state.saleChannelData}
                      components={components}
                      value={this.state.saleChannel}
                      onChange={this.handleChangeSelect('saleChannel')}
                      placeholder=''
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </React.Fragment>
                }
              </div>
            </Grid>
          </Grid>

          {subLots}
          {this.renderOptionalsGrid()}
          {this.renderCarDetail()}
        </div>

        <Dialog
          fullScreen
          open={this.state.openOrderDialog}
          onClose={this.handleCloseOrderDialog.bind(this)}
        >
          <RUCarOrderAssociation
            handleClose={this.handleCloseOrderDialog.bind(this)}
            carDetail={this.state.ruL4Data}
            carModelData={this.props.negotiationLot}
            reloadL4Table={this.props.reloadL4Table.bind(this)}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialogForced}
          onClose={this.handleCloseDialogForced}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialogForced}
            handleClose={this.handleCloseDialogForced.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

CarDetailInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  refreshOptionalsGrid: PropTypes.func
};


const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(CarDetailInfo));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/UsedRentalsCarsList/RUCarDetailInfo.js